module.exports = __webpack_public_path__ + "img/icon-github.c99d90cf.svg";